import cx from 'classnames';
import { PageTitle, SupportEmail } from 'components/ui';
import { useWhiteLabelContext } from 'components/white-label';
import { Organization } from 'lib/types/company';
import { createElement, ReactNode } from 'react';
import css from './ErrorPage.module.scss';

interface IErrorView {
  children: ReactNode;
  className?: string;
  imgSrc: string;
  message: string;
  pageTitle: string;
}

const ErrorView = ({
  children,
  className,
  imgSrc,
  message,
  pageTitle,
}: IErrorView) => (
  <main className={cx(css.main, className)}>
    <PageTitle title={pageTitle} />
    <div className={css.container}>
      <img alt="" className={css.image} src={imgSrc} />
      <p className={css.message}>{message}</p>
      <p className={css.description}>{children}</p>
    </div>
  </main>
);

const EthenaErrorView = ({ message }: Pick<IErrorView, 'message'>) => (
  <ErrorView
    className={css.ethena}
    imgSrc="https://assets.goethena.com/m/4b5fb11718f3308c/original/sad-cactus.png"
    message={message || 'The application has encountered an unknown error.'}
    pageTitle="Something went wrong!"
  >
    Please send us a message at <SupportEmail />
    <br />
    and we will help you resolve this issue.
  </ErrorView>
);

const LifeLabsErrorView = ({ message }: Pick<IErrorView, 'message'>) => (
  <ErrorView
    className={css.lifeLabs}
    imgSrc="https://assets.goethena.com/m/419b653b32422fe4/original/lifelabs-error.svg"
    message={message || "Something's not right."}
    pageTitle="Something's not right."
  >
    Send us a message at <SupportEmail /> and we will help fix this issue.
  </ErrorView>
);

interface IErrorPageProps {
  message?: string;
}

export const ErrorPage = ({ message }: IErrorPageProps) => {
  const { organization } = useWhiteLabelContext();
  return createElement(
    organization === Organization.LIFE_LABS
      ? LifeLabsErrorView
      : EthenaErrorView,
    { message }
  );
};
